<div class="referral-program-container">
  <div class="referral-program-card">
    <div class="referral-program-header">
      <h2>Referral Program</h2>
    </div>
    
    <div class="referral-program-content">
      <p class="referral-intro">
        If you manage a social media channel or group focused on the USMLE, and you have a strong following—whether Arabic-speaking, English-speaking, or both—we'd love to connect with you.
      </p>
      
      <p class="referral-benefits">
        We offer exclusive benefits to our partners through our <strong>Referral Program</strong>.
      </p>
      
      <div class="referral-contact">
        <p>To learn more and explore potential collaboration, email us at:</p>
        <a href="mailto:marketing&#64;elhusseinyusmleprep.com" class="email-link">
          marketing&#64;elhusseinyusmleprep.com
        </a>
        <p class="contact-note">Please include links to your channel(s) or group(s), along with proof of ownership.</p>
      </div>
      
      <div class="referral-more-info">
        <button pButton type="button" label="Click here to learn more" icon="pi pi-arrow-right" class="p-button-outlined" (click)="openAffiliateLink()"></button>
      </div>
    </div>
  </div>
</div>
